import { jsx as _jsx } from "react/jsx-runtime";
import { RadioCard } from "../../../../../../components/RadioCard";
import { getStoreFilterCategoryIcon } from "../../../../../../components/StoreLocator/utils/getStoreFiltersIcons";
import { useTranslations } from "../../../../../../providers/useTranslations";
import styles from "./StoreLocatorFilterCategory.module.scss";
export const StoreLocatorFilterCategoryItem = ({ filter, onChange, isChecked, filterCategory, }) => {
    const { __ } = useTranslations();
    const { label, value } = filter;
    return (_jsx(RadioCard, { value: value, onChange: onChange, title: label, groupName: filterCategory, isChecked: isChecked, type: "checkbox", icon: getStoreFilterCategoryIcon({
            categoryKey: filterCategory,
            filterKey: filter.key,
            colorsClassName: styles.colors,
            filtersItemIconContainerClassName: styles.filtersItemIconContainer,
        }) }));
};
//# sourceMappingURL=StoreLocatorFIlterCategoryItem.js.map